import * as React from 'react';

const SvgSms = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path d="M21.857 0h-18a2.143 2.143 0 00-2.143 2.143V17.76a.497.497 0 010 .154L.086 22.286A1.286 1.286 0 001.286 24a1.08 1.08 0 00.325 0l6.172-1.714h14.074A2.143 2.143 0 0024 20.143v-18A2.143 2.143 0 0021.857 0z" />
    </svg>
  );
};

export default SvgSms;
